import moment from 'moment';
import React from 'react'
import { Modal, Button, Row, Col, Spinner, Container } from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
const NftsuccessfulModal = ({ showNftSuccessModal, handleCloseNftSuccessPop, buyTransactionHash, nftBoxValue }) => {

  const currentDate = moment().format('MMMM Do YYYY, h:mm a');
  const truncatedHash = `${buyTransactionHash.substring(0, 4)}..${buyTransactionHash.slice(-4)}`;
  const copieBtn = async () => {
    toast.dismiss()
    toast.success(`Copied!!`);
  };
  return (
    <>
      <Modal show={showNftSuccessModal} size="md" className='nftmodal' centered>

        {/* <img src="assets/images/nftbg2.png" className="position-absolute w-100  " style={{ top: 0, opacity: 0.7,height:"40%",  zIndex: "-1" }} alt="" /> */}
        <img src="assets/images/nftbg1.png" className="position-absolute w-100" style={{ bottom: 50, height: "40%", }} alt="" />

        <Modal.Body className='py-4 pt-sm-2 '>
          <Container >
            <div className='text-center d-flex flex-column align-items-center justify-content-center'>
              <div>
                <img src="assets/images/nftsuccess.gif" style={{ maxWidth: 150, maxHeight: 150 }} alt="" />
              </div>
              <h3 style={{ fontWeight: 700 }}>Payment Success!</h3>
              <p className='mb-0'>Your payment has been successfully done.</p>
              <hr style={{ width: "60%", alignSelf: "center" }} />
              <p className='mb-1'>Total Payment</p>
              <h2 style={{ fontWeight: 700 }}>${nftBoxValue} </h2>
              <br />
              <Row className='w-100 align-items-baseline'>
                <Col lg={4} sm={4} xs={4} className='text-start'>
                  <p className='mb-0'>Date & Time</p>
                </Col>
                <Col lg={8} sm={8} xs={8} className='text-end'>
                  <p className='text-white mb-0' style={{ fontWeight: 700, wordWrap: "break-word" }}>{currentDate}</p>
                </Col>
              </Row>
              <Row className='w-100 align-items-center'>
                <Col lg={6} sm={6} xs={6} className='text-start'>
                  <p className='mb-0'>Transaction ID</p>
                </Col>
                <Col lg={6} sm={6} xs={6} className='text-end'>
                  <p className='text-white mb-0' style={{ fontWeight: 700 }}>{truncatedHash} 
                  <CopyToClipboard text={buyTransactionHash}>
                    <span
                      title="Click to Copy"
                      className="mr-copylink"
                      id="token-buy-button"
                      onClick={copieBtn}
                      style={{ cursor: "pointer", color: "#fff" }}
                    >
                      &nbsp;<i className="fa fa-clone "></i>
                    </span>
                  </CopyToClipboard>
                  </p>
                </Col>
              </Row>

              <br />
              <button className="nftbox-submit w-100" onClick={handleCloseNftSuccessPop} >
                Done

              </button>
            </div>
          </Container>
        </Modal.Body>

      </Modal></>
  )
}

export default NftsuccessfulModal